import React from "react";
import "./AwesomeFacts.css";

function AwesomeFacts() {
  return (
    <section className="awesome-facts">
      <div className="awesome-container">
        <h2 className="awesome-title">Awesome Facts</h2>

        <p className="awesome-text">
          Gypsona is one of the leading fly ash bricks manufacturers in
          Delhi-NCR. Fly Ash is a waste generated from Thermal Power Plants.
          Fal G is a technological renaissance of the age-old pozzolanic
          industry proven for its strength and durability. Fal G is a ground
          blend of Fly Ash (Fa), Lime (L), and Gypsum (G) in suitable
          proportions which, upon hydration, yields strength in the range of
          40 to 400 Kg/Sqcm, rendering a totally water-impervious hard matrix
          with the formation of mineralogical phases during hydration similar
          to those of ordinary Portland cement (OPC). Kalesh Build Solutions
          is committed to providing the best quality and reliable building
          products to achieve the highest level of customer satisfaction in
          the industry. As a client-centric organization, we build strong
          relationships with our clients through our unwavering commitment to
          quality. To provide superior products, we maintain strict quality
          checks from the procurement of raw materials to the finished
          products as per customer specifications.
        </p>
      </div>
    </section>
  );
}

export default AwesomeFacts;